export type { DepositOwnerProvider, ProviderType } from "./types";
export { createLocalWalletProvider } from "./local-wallet";
export {
  createConnectedWalletProvider,
  type ConnectedWalletAddresses,
} from "./connected-wallet";

// ---- Swap the active provider here ----
import type { ProviderType } from "./types";
export const ACTIVE_PROVIDER: ProviderType = "local";
